import { NavLink } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

const Link = ({ to, state, end = false, label, icon }) => (
  <NavLink
    to={to}
    state={state}
    end={end}
    className={({ isActive }) => twMerge(
      'peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-hidden ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent disabled:pointer-events-none disabled:opacity-50 group-has-data-[sidebar=menu-action]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:size-8! group-data-[collapsible=icon]:p-2! [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0',
      isActive
        ? 'bg-sidebar-accent text-sidebar-accent-foreground'
        : 'text-muted-foreground'
    )}
  >
    {icon}
    <span>
      {label}
    </span>
  </NavLink>
)

export default Link
